import moment from 'moment';
import curry from 'lodash/curry';

export const fromFormat = curry((format, value) => moment(value, format), 2);
export const startOf = curry((unit, date) => date.startOf(unit), 2);
export const endOf = curry((unit, date) => date.endOf(unit), 2);
export const format = curry((format, date) => date.format(format), 2);
